import React, { useEffect } from 'react';
import { useThemeMode } from '../../ThemeContext';
import SiteHeader from '../../components/SiteHeader';
import Footer from '../Home/Footer';
import './SeoPages.css';

/**
 * Shared chrome for static SEO landing pages — same nav as Home.
 */
function SeoPageLayout({ children, activeNav }) {
  const { mode } = useThemeMode();

  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  return (
    <div
      className={`seo-page ${mode === 'dark' ? 'seo-page-dark' : 'seo-page-light'}`}
    >
      <SiteHeader activeNav={activeNav} />
      <main className="seo-page-main">{children}</main>
      <Footer />
    </div>
  );
}

export default SeoPageLayout;
